var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLiReplied = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48532 3.53169H5.0507C3.63282 3.53169 2.92388 3.53169 2.38233 3.80762C1.90596 4.05035 1.51866 4.43765 1.27594 4.91401C1 5.45557 1 6.58646 1 8.00434V10.7048C1 11.4896 1 11.882 1.08627 12.2039C1.32036 13.0776 2.00277 13.76 2.87644 13.9941C3.19838 14.0804 3.59078 14.0804 4.37558 14.0804V16.0513C4.37558 16.501 4.37558 16.7258 4.46776 16.8413C4.54793 16.9417 4.66949 17.0001 4.79799 17C4.94574 16.9998 5.12131 16.8594 5.47244 16.5785L7.48552 14.968C7.89675 14.639 8.10237 14.4745 8.33133 14.3576C8.53447 14.2538 8.7507 14.1779 8.97415 14.1321C9.22602 14.0804 9.48933 14.0804 10.016 14.0804H11.2955C12.7134 14.0804 13.1169 14.0804 13.6584 13.8044C13.939 13.6615 14.1887 13.4684 14.3961 13.2365M9.43896 3.53169H15.7682C17.8655 3.53169 19.5657 4.388 19.5657 6.48532C19.5657 8.58264 17.8655 9.43896 15.7682 9.43896H15.3462M9.43896 3.53169L11.1267 1.8439L11.9706 1M9.43896 3.53169L11.1267 5.21948L11.9706 6.06337",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLiReplied, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/liReplied.9d8b89bc.svg";
export { ForwardRef as ReactComponent };